"use client";

import {
  createContext,
  useContext,
  ReactNode,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

type Verification = {
  method: "sms" | "email";
  value: string | null;
};

type LoginContextType = {
  verification: Verification;
  setVerification: React.Dispatch<React.SetStateAction<Verification>>;
  showVerificationHelp: boolean;
  setShowVerificationHelp: Dispatch<SetStateAction<boolean>>;
};

const LoginContext = createContext<LoginContextType | null>(null);

export function useLogin(): LoginContextType {
  const context = useContext(LoginContext);
  if (context === null) {
    throw new Error("useLogin must be used within a LoginProvider");
  }
  return context;
}

export function LoginProvider({ children }: { children: ReactNode }) {
  const [verification, setVerification] = useState<
    LoginContextType["verification"]
  >({
    method: "sms",
    value: null,
  });

  const [showVerificationHelp, setShowVerificationHelp] = useState(false);

  const ctxValue = {
    verification,
    setVerification,
    showVerificationHelp,
    setShowVerificationHelp,
  };

  return (
    <LoginContext.Provider value={ctxValue}>{children}</LoginContext.Provider>
  );
}
